export const MAPTOKEN = "pk.eyJ1IjoibHVrZWh0cmF2aXMiLCJhIjoiY2xveDloN3BmMTRrZDJqbzlxNmNnNTk5NSJ9.HRiCyxYZ4CFSpqUW8ehkNg"
